if (!customElements.get('gift-card-recipient')) {
  class GiftCardRecipient extends HTMLElement {
    connectedCallback() {
      this.recipientEmail = this.querySelector('[name="properties[Recipient email]"]');
      this.recipientSendOn = this.querySelector('[name="properties[Send on]"]');
      this.recipientOffsetProperty = this.querySelector('[name="properties[__shopify_offset]"]');

      // Set the timezone offset property input and enable it
      if (this.recipientOffsetProperty) {
        this.recipientOffsetProperty.value = new Date().getTimezoneOffset().toString();
        this.recipientOffsetProperty.removeAttribute('disabled');
      }

      this.recipientCheckbox = this.querySelector('.recipient-checkbox');
      if (this.recipientCheckbox) {
        this.recipientCheckbox.addEventListener('change', () => this.synchronizeProperties());
        this.synchronizeProperties();
      }

      // Make the entire date input clickable to open the date picker
      if (this.recipientSendOn) {
        // Ensure min date is set to today to prevent past dates
        const today = new Date().toISOString().split('T')[0];
        this.recipientSendOn.setAttribute('min', today);
        
        // Validate date selection to prevent past dates
        this.recipientSendOn.addEventListener('change', (e) => {
          const selectedDate = e.target.value;
          if (selectedDate && selectedDate < today) {
            e.target.value = today;
          }
        });
        
        // Prevent manual input of past dates
        this.recipientSendOn.addEventListener('input', (e) => {
          const selectedDate = e.target.value;
          if (selectedDate && selectedDate < today) {
            e.target.value = today;
          }
        });
        
        this.recipientSendOn.addEventListener('click', (e) => {
          // Only trigger if clicking on the input itself, not if already opening picker
          if (e.target === this.recipientSendOn) {
            // Use showPicker() if available (modern browsers)
            if (typeof this.recipientSendOn.showPicker === 'function') {
              e.preventDefault();
              this.recipientSendOn.showPicker();
            } else {
              // Fallback: focus and trigger click on the calendar icon
              this.recipientSendOn.focus();
            }
          }
        });
      }
    }

    synchronizeProperties() {
      if (this.recipientCheckbox && this.recipientCheckbox.checked) {
        if (this.recipientEmail) {
          this.recipientEmail.setAttribute('required', '');
          this.recipientEmail.removeAttribute('disabled');
        }
        if (this.recipientSendOn) {
          this.recipientSendOn.removeAttribute('disabled');
        }
        if (this.recipientOffsetProperty) {
          this.recipientOffsetProperty.removeAttribute('disabled');
        }
      } else {
        if (this.recipientEmail) {
          this.recipientEmail.removeAttribute('required');
          this.recipientEmail.setAttribute('disabled', '');
        }
        if (this.recipientSendOn) {
          this.recipientSendOn.setAttribute('disabled', '');
        }
        if (this.recipientOffsetProperty) {
          this.recipientOffsetProperty.setAttribute('disabled', '');
        }
      }
    }
  }

  customElements.define('gift-card-recipient', GiftCardRecipient);
}
